<template>
  <div v-if="showOnlineNotify || showOfflineNotify" class="net-notification">
    <div v-if="showOnlineNotify" class="online">
      <icon class="alert-icon" name="success" />
      <span>{{ $t('network-online') }}</span>
      <div class="close-button escCloseTab" @click="close()">
        <icon name="cross" />
      </div>
    </div>
    <div v-if="showOfflineNotify" class="offline">
      <icon class="alert-icon" name="circle-alert" />
      <span>{{ $t('network-offline') }}</span>
      <div class="close-button escCloseTab" @click="close()">
        <icon name="cross" />
      </div>
    </div>
  </div>
</template>
<script>
import Icon from 'com/Icon'

export default {
  name: 'OnlineOffline',
  components: {
    Icon
  },
  data() {
    return {
      showOnlineNotify: false,
      showOfflineNotify: false
    }
  },
  methods: {
    init() {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
    },
    updateOnlineStatus() {
      const isOnline = window.navigator.onLine
      this.showOnlineNotify = isOnline
      this.showOfflineNotify = !isOnline
      // 5秒后自动消失
      setTimeout(() => {
        if (this.showOnlineNotify) {
          this.showOnlineNotify = false
        }
      }, 5000)
    },
    close() {
      this.showOnlineNotify = false
      this.showOfflineNotify = false
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="less" scoped>
.net-notification {
  width: 800px;
  color: #fff;
  font-size: 14px;
  position: fixed;
  top: 3px;
  left: 50%;
  margin-left: -400px;
  z-index: 999999;
  .alert-icon {
    color: #fff;
    margin-right: 5px;
  }
}
.offline {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: #ff681e;
}
.online {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: #00aaff;
}
.close-button {
  position: absolute;
  right: 15px;
  top: 12px;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
}
</style>
